import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
// import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Inject } from '@angular/core';

// const BASE_URL: string = environment.apiEndPoint;
// const tempUrl = BASE_URL + 'v1/api';

@Injectable({
  providedIn: 'root'
})

export class CoreHttpService {

  public BASE_URL: string ;
  // TODO: OPTIMIZE ALL OF BELOW CODE. ADD ERROR HANDLING IN INTERCEPTOR
  constructor(private http: HttpClient, @Inject('ENV_CONFIG') public environment: any) {
    this.BASE_URL = this.environment.apiEndPoint;
   }

  /**
   * generic get api call
   * @param url - url
   * @param params - params
   */
  public doGet(url: string, params?: HttpParams): Observable<any> {
    if (params) {
      return this.http.get(this.BASE_URL + url, { params });
    } else { return this.http.get(this.BASE_URL + url); }
  }

  /**
   * generic post api call
   * @param url - url
   * @param data - data
   */
  public doPost(url: string, data: object): Observable<any> {
    // return this.http.post(BASE_URL + url, data); // http://localhost:3000/v1/api/suriname/users
    return this.http.post(this.BASE_URL + url, data);
  }

  /**
   * check for api call type and call generic method
   * @param url - url
   * @param type - type
   * @param data - data
   */
  public doCheck(url: string, type: string, data?: any): Observable<any> {

    let response: Observable<any>;
    switch (type) {
      case 'GET':
        if (data) {
          const params = new HttpParams({ fromObject: data });
          response = this.doGet(url, params);
        } else { response = this.doGet(url); }
        break;

      case 'POST':
        response = this.doPost(url, data);
        break;
    }
    return response;
  }
}

